<template>
  <Dropdown :no-toggle="true">
    <div
      class="search-triger"
      :class="customClass"
      aria-haspopup="true"
      @click="searchFocus"
    >
      <SearchIcon />
      <span>{{ searchText ? searchText : "|__" }}</span>
    </div>

    <template #body>
      <div class="search-body">
        <div class="control">
          <input
            ref="searchBox"
            class="input"
            type="text"
            name="search"
            placeholder="Search for..."
            :value="searchText"
            autocomplete="off"
            @input="search"
          />
        </div>
        <button class="delete" @click="searchClean"></button>
      </div>
    </template>
  </Dropdown>
</template>

<script setup>
import { ref, computed, nextTick } from "vue";
import { useStore } from "vuex";
import Dropdown from "./Dropdown.vue";
import SearchIcon from "./icons/Search.vue";

defineProps({
  customClass: {
    type: String,
    default: "",
  },
});

const store = useStore();
const searchBox = ref(null);

const searchText = computed(() => store.state.match.searchText);

function search(event) {
  store.commit("SET_SEARCH_TEXT", event.target.value);
}

function searchClean() {
  store.commit("SET_SEARCH_TEXT", "");
}

function searchFocus() {
  nextTick(() => {
    setTimeout(() => {
      if (searchBox.value && document.activeElement !== searchBox.value) {
        searchBox.value.focus();
      }
    }, 50);
  });
}
</script>

<style scoped>
.search-triger {
  display: flex;
  align-items: center;
  line-height: 25px;
  max-width: 70px;

  span {
    display: inline-block;
    font-size: 14px;
    text-decoration: underline;
    max-width: 7ch;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.search-body {
  display: flex;
  background-color: var(--body-color-second);
  width: 200px;
  border-radius: 4px;
  box-shadow:
    0 2px 3px var(--font-color),
    0 0 0 1px var(--font-color);
  padding: 0.5rem;

  input {
    color: var(--font-color);
    background-color: var(--body-color);
    border: 1px solid #ccc;
    width: 100%;
    height: 100%;

    &::placeholder {
      color: #888;
      font-size: 14px;
      font-style: italic;
    }
  }
}
</style>
